export default __webpack_public_path__ + "static/media/starrepair_3.a2d28070.jpg";